import http from '../app/httpService';
import uuid from 'react-uuid';

const apiEndpoint = process.env.REACT_APP_MARKET_API+"QualityAttributeValueMarketAssignment/";

export async function getQualityAttributeValueMarketAssignments(marketId) {
  const {data: Assignments} = await http.get(apiEndpoint+"Market/"+marketId);
  return Assignments;
}

export async function addQualityAttributeValueMarketAssignment(assignment) {
  // Ensure eventId is set
  if (!assignment.eventId) {
    assignment.eventId = uuid();
  }
  const {data: Assignment} = await http.post(apiEndpoint, assignment);
  return Assignment;
}

export async function addQualityAttributeValueMarketAssignments(assignments) {
  // Ensure eventId is set for each assignment
  const assignmentsWithEventId = assignments.map(assignment => ({
    ...assignment,
    eventId: assignment.eventId || uuid()
  }));
  const {data: Assignments} = await http.post(apiEndpoint+"Batch", assignmentsWithEventId);
  return Assignments;
}

export async function updateQualityAttributeValueMarketAssignment(assignment) {
  // Ensure eventId is set
  if (!assignment.eventId) {
    assignment.eventId = uuid();
  }
  const {data: Assignment} = await http.put(apiEndpoint, assignment);
  return Assignment;
}

export async function endQualityAttributeValueMarketAssignment(marketId, qualityAttributeValueId, eventId) {
  const assignmentInput = {
    qualityAttributeValueId: qualityAttributeValueId,
    marketId: marketId,
    eventId: eventId || uuid()
  };
  const {data: Assignment} = await http.put(apiEndpoint+"End/"+marketId, assignmentInput);
  return Assignment;
}

export async function getActiveQualityAttributeValueIdsByMarket(marketId, marketDate) {
  const marketDateParam = marketDate ? `?marketDate=${marketDate}` : '';
  const {data: QualityAttributeValueIds} = await http.get(apiEndpoint+"ActiveIds/Market/"+marketId+marketDateParam);
  return QualityAttributeValueIds || [];
}


